import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ExpandingCard.css';
import expandIcon from '../../assets/icons/rawora-icon-expand.svg';

const ExpandingCard = ({ title, subtitle, description, image, isActive, onClick, isBlack }) => {
  const [shouldCollapse, setShouldCollapse] = useState(false);
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    if (!isActive) {
      setShowContent(false);
      // Start collapse after content fade
      const timer = setTimeout(() => {
        setShouldCollapse(true);
      }, 0);
      return () => clearTimeout(timer);
    } else {
      setShouldCollapse(false);
      const timer = setTimeout(() => {
        setShowContent(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isActive]);

  return (
    <div
      className={`card ${shouldCollapse ? '' : 'expanded'} ${isActive ? 'active' : ''} ${isBlack ? 'black' : ''}`}
      onClick={onClick}
    >
      <img src={expandIcon} alt="Expand" className="expand-icon" />
      {showContent && (
        <AnimatePresence>
          <motion.div 
            className="card-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
          >
            <div className="card-image" style={{ backgroundImage: `url(${image})` }}>
              <div className="card-overlay"></div>
            </div>
            <div className={`card-content ${isBlack ? 'black' : ''}`}>
              <h3 dangerouslySetInnerHTML={{ __html: title }} />
              <h4>{subtitle}</h4>
              <p>{description}</p>
            </div>
          </motion.div>
      </AnimatePresence>
      )}
    </div>
  );
};

export default ExpandingCard; 